import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=37556541&"
import script from "./messages.vue?vue&type=script&lang=ts&"
export * from "./messages.vue?vue&type=script&lang=ts&"
import style0 from "./messages.vue?vue&type=style&index=0&id=37556541&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports